export enum EbayVariantFieldType {
  Sku = "sku",
  Price = "price",
  Aspect = "aspect",
}
